<div>
  <div *ngIf="(taskWithFormModel$ | async) as taskWithFormModel; else stillLoading" class="box-body">

    <h3 class="title flex p-t-xs">
      {{ taskWithFormModel.task.translationKeys.title | translate | translateAndFormatVariables: taskWithFormModel.task.variables: (trigger$|async) }}
      <span class="default-recipient text-xs" *ngIf="taskWithFormModel.task.isFallbackRecipient"
            tooltip="{{'INBOX.default_recipient'|translate}}">
      <em class="fa fa-light fa-user-check "></em>
    </span>
    </h3>

    <div *ngIf="taskWithFormModel?.taskFormModel">
      <gp-workflow-form [formModel]="taskWithFormModel.taskFormModel"
                        [taskDefinitionKey]="taskWithFormModel.task.taskDefinitionKey"
                        (cancelFormOutcome)="onClose()"
                        (submitFormOutcome)="onCompleteTaskWithForm($event)">
      </gp-workflow-form>
    </div>
    <div *ngIf="!taskWithFormModel.taskFormModel">
      <ng-container *ngIf="taskWithFormModel?.task?.taskDefinitionKey === 'fillOnboardingForm'; else genericBody">
        <gp-onboarding-fill-form-task [task]="taskWithFormModel.task" [trigger$]="trigger$">
        </gp-onboarding-fill-form-task>
      </ng-container>

      <ng-template #genericBody>
        <!-- TODO: we should build a generic one when needed -->
      </ng-template>
    </div>

  </div>
  <ng-template #stillLoading>
    <div class="p-x-sm">
      <p>
        <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
      </p>
      <p>
        <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
      </p>
      <p>
        <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
      </p>
    </div>
  </ng-template>
</div>
